export const CSD_CONSENT_EVENT = 'csd:consent-changed';
const STORAGE_KEY = 'csd:cookie-consent';
const VERSION = 1;

export type CsdConsent = {
  version: number;
  essential: true;
  analytics: boolean;
  marketing: boolean;
  updatedAt: string;
};

const defaults = (): CsdConsent => ({
  version: VERSION,
  essential: true,
  analytics: false,
  marketing: false,
  updatedAt: '',
});

export const getCsdConsent = (): CsdConsent => {
  if (typeof window === 'undefined') return defaults();
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (!parsed || parsed.version !== VERSION) return defaults();
    return {
      version: VERSION,
      essential: true,
      analytics: parsed.analytics === true,
      marketing: parsed.marketing === true,
      updatedAt: typeof parsed.updatedAt === 'string' ? parsed.updatedAt : '',
    };
  } catch {
    return defaults();
  }
};

export const hasCsdAnalyticsConsent = () => getCsdConsent().analytics;
export const hasCsdMarketingConsent = () => getCsdConsent().marketing;

export const clearCsdTrackingStorage = () => {
  ['csd:session-id', 'csd:natura-visitor-tracked:v1'].forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};

export const saveCsdConsent = (analytics: boolean, marketing: boolean) => {
  const next: CsdConsent = {
    version: VERSION,
    essential: true,
    analytics,
    marketing,
    updatedAt: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  if (!analytics) clearCsdTrackingStorage();
  window.dispatchEvent(new CustomEvent(CSD_CONSENT_EVENT, { detail: next }));
  return next;
};

export const subscribeCsdConsent = (listener: (consent: CsdConsent) => void) => {
  const handler = (event: Event) => listener((event as CustomEvent<CsdConsent>).detail);
  window.addEventListener(CSD_CONSENT_EVENT, handler);
  return () => window.removeEventListener(CSD_CONSENT_EVENT, handler);
};
